import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@app/dev/helpers/translator';

import tournamentPrizesIcon from '../../../../images/tournament-prizes-icon.png';

const TournamentPrizes = ({ tournament }) => (
    <div className="tournament-stats tournament-prizes">
        <div className="stats-top">
            <img src={tournamentPrizesIcon} />
            <h2>{t('Prizes')}</h2>
        </div>
        <div className="stats-content">
            <div className="stats-content-inner">
                {tournament.PrizeStructure.map(item => <p key={item.PlaceNumber}>
                    {t('Place')} - {item.PlaceNumber}

                    <span className="stats-percent">{item.PrizePercent}%</span>
                </p>)}
            </div>
        </div>
    </div>
);

TournamentPrizes.propTypes = {
    tournament: PropTypes.object.isRequired,
};

export default TournamentPrizes;